import * as Rx from 'rxjs';
import {catchError, map} from "rxjs/operators";
import {ApiClient} from "./util";
import {environment} from "../../env/environment";
import {LiveTicketOrder} from '../entity/live';

export class MagticketApiClient {

  static getTickets(eventId: number): Rx.Observable<LiveTicketOrder[] | "NOT_FOUND"> {
    return ApiClient.getJson(environment.baseURL.magticketAPI, `api/ticket/?event_id=${eventId}`).pipe(
      map(x => {
        const resp = x as MagticketApiResponse<LiveTicketOrder[]>;
        return resp.results;
      }),
      catchError(e => {
        if (e.status !== 200) {
          return Rx.of("NOT_FOUND" as "NOT_FOUND");
        } else {
          throw e;
        }
      })
    );
  }

}

type MagticketApiResponse<T> = {
  count: number;
  next?: string;
  privious?: string;
  results: T;
}